module.exports = __webpack_public_path__ + "img/2_109.232fd113.png";